import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import { AllowAccess } from "../../../components/BlockAccess";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  MangeUserTable,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { statusOptions } from "../options_common";

export const ManageUser = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
    reset: false,
  });
  const [editId, setEditId] = useState();
  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    middleName: "",
    referralCode: "",
    platform: "TREASURY",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [adminUsers, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [details, setDetails] = useState({});
  const [branches, setBranches] = useState();
  const [search, setSearch] = useState("");
  // const [, setPage] = useState(0);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getUsers();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (e, name) => {
    setFormData((prev) => ({ ...prev, [name]: e.value }));
  };

  const resetForm = () => {
    setFormData({
      branchId: "",
      departmentId: "",
      email: "",
      roleId: "",
      firstName: "",
      gender: "",
      lastName: "",
      middleName: "",
      referralCode: "",
      roleNameToBeAssigned: "",
      status: "",
    });
  };

  const [manageDepart, setManageDepart] = useState();
  const getManageDepart = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/departments`, {
        headers: authHeader(),
      });
      const data = response.data;
      const filteredDepts = data.filter((data) => data.status === "ACTIVE");
      if (data) {
        setManageDepart(filteredDepts);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getAllBranches = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/branches`, {
        headers: authHeader(),
      });
      const data = response.data;
      const filteredBranches = data.filter((data) => data.status === "ACTIVE");
      if (data) {
        setBranches(filteredBranches);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [manageRole, setManageRole] = useState([]);
  const getManageRole = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/role`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      if (resultData) {
        setManageRole(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false, reset: false });
    resetForm();
  };

  const [genders, setGender] = useState();
  const getGender = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/gender`, {
        headers: authHeader(),
      });
      const resultData = await response.data;
      const filteredGenders = resultData.filter((data) => data.status === "ACTIVE");
      if (resultData) {
        setGender(filteredGenders);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getUsers = async (page) => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/users?search=${search}`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      if (resultData) {
        setIsLoading(false);
        setUsers(resultData);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const addManageUser = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/users`,
        { ...obj, platform: "TREASURY", platformType: "TREASURY" },
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData) {
        getUsers();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        message.success({
          content: formData.message,
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
    } catch (error) {
      if (error?.response?.statusCode === 400) {
        message.error("Please Fill All fields!!.");
      }
      const errorMsg = error?.response?.data?.message;
      setModal({ add: false });
      message.error({
        content: errorMsg,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      setIsLoadBtn(false);
      setIsLoading(false);
    }
  };

  const resetUser = async (email) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/users/unlock-user/?email=${email}&usage=ADMIN_TREASURY`,
        {},
        {
          headers: authHeader(),
        }
      );
      const formData = await response.data;
      if (formData) {
        getUsers();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ reset: false });
        message.success({
          content: formData.message,
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const errorMsg = error.response.data.message;
      setModal({ reset: false });
      message.error({
        content: errorMsg,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      setIsLoadBtn(false);
      setIsLoading(false);
    }
  };

  const editManageUser = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/users/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getUsers();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ edit: false });
        resetForm();
        message.success({ content: formData.message });
      }
      return { formData };
    } catch (error) {
      const errorMsg = error.response.data.message;
      if (error.response.status === 404) {
        message.error({ content: "Resource not found!!." });
      } else {
        message.error({ content: errorMsg });
      }
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
      resetForm();
    }
  };

  const onFormSubmit = () => {
    if (formData.status && formData.branchId && formData.departmentId && formData.roleId && formData.genderId) {
      addManageUser(formData);
    } else {
      toast.error("Please Make Sure You've Selected the Branch, Department, Gender, Role and Status", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onEditSubmit = () => {
    editManageUser(formData);
    // resetForm();
    // setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    const nameArr = items.contactName.split(" ");
    let adminFirstName;
    let adminMiddleName;
    let adminLastName;
    if (nameArr.length === 3) {
      adminFirstName = nameArr[0];
      adminMiddleName = nameArr[1];
      adminLastName = nameArr[2];
    } else if (nameArr.length === 2) {
      adminFirstName = nameArr[0];
      adminLastName = nameArr[1];
    } else {
      adminFirstName = nameArr[0];
    }
    let branchid;
    if (items.branch) {
      branchid = items.branch.id;
    }

    let departmentid;
    if (items.department) {
      departmentid = items.department.id;
    }
    setFormData({
      branchId: branchid,
      genderId: items?.gender?.id,
      departmentId: departmentid,
      email: items.email,
      firstName: adminFirstName,
      lastName: adminLastName,
      middleName: adminMiddleName,
      assignedRoleId: items.assignedRole?.id,
      status: items.status,
    });
    setDetails(items);
    setEditId(items.id);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = adminUsers?.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getUsers();
    getGender();
    getManageRole();
    getManageDepart();
    getAllBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const roleManagementOptions =
    manageRole?.map((role) => ({
      label: role.roleName,
      value: role.id,
    })) ?? [];

  const departmentManagementOptions =
    manageDepart?.map((dept) => ({
      label: dept.name,
      value: dept.id,
    })) ?? [];

  const branchManagementOptions =
    branches?.map((branch) => ({
      label: branch.name,
      value: branch.id,
    })) ?? [];

  const onViewClick = (item) => {
    setModal({ view: true });
    setDetails(item);
  };

  const onResetClick = (item) => {
    setModal({ reset: true });
    setDetails(item);
    console.log(item)
  };

  const genderOptions =
    genders?.map((gender) => ({
      label: gender.gender,
      value: gender.id,
    })) ?? [];

  return (
    <React.Fragment>
      <Head title="User Management" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">User Management</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Users..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_ADMIN_USER"]}>
                    <Button className="mr-4" color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus"></Icon>
                      <span>Add User</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <MangeUserTable
                adminUsers={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                handleEdit={() => setModal({ edit: true })}
                onViewClick={onViewClick}
                onResetClick={onResetClick}
              />
            )}
          </Card>
          <div className="card-inner">
            {adminUsers && adminUsers.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={adminUsers?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No user found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add User</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        // defaultValue={formData.firstName}
                        placeholder="First Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.firstName && <span className="invalid">{errors.firstName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Middle Name</label>
                      <input
                        type="text"
                        name="middleName"
                        placeholder="Middle Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        // defaultValue={formData.lastName}
                        placeholder="Last Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.lastName && <span className="invalid">{errors.lastName.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Email</label>
                      <input
                        type="text"
                        name="email"
                        // defaultValue={formData.email}
                        placeholder="Email"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.email && <span className="invalid">{errors.email.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        name="status"
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                        // ref={register({
                        //   required: "Status is required",
                        // })}
                      />
                      {errors.status && (
                        <span className="invalid text-danger font-italic" style={{ fontSize: "12px" }}>
                          {errors.status.message}
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Branch</label>
                      <RSelect
                        name="branchId"
                        options={branchManagementOptions}
                        // ref={register({
                        //   required: "Branch is required",
                        // })}
                        onChange={(e) => setFormData({ ...formData, branchId: parseInt(e.value) })}
                      />
                      {errors.branchId && (
                        <span className="invalid text-danger font-italic" style={{ fontSize: "12px" }}>
                          {errors.branchId.message}
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Department</label>
                      <RSelect
                        options={departmentManagementOptions}
                        // ref={register({
                        //   required: "Department is required.",
                        // })}
                        name="departmentId"
                        onChange={(e) => setFormData({ ...formData, departmentId: parseInt(e.value) })}
                      />
                      {errors.departmentId && (
                        <span className="invalid text-danger" style={{ fontSize: "12px" }}>
                          {errors.departmentId.message}
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Gender</label>
                      <RSelect
                        options={genderOptions}
                        // ref={register({
                        //   required: "Gender is required.",
                        // })}
                        name="gender"
                        placeholder="Select Gender"
                        onChange={(e) => setFormData({ ...formData, genderId: e.value })}
                      />
                      {errors.gender && (
                        <span className="invalid text-danger font-italic" style={{ fontSize: "12px" }}>
                          {errors.gender.message}
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Roles</label>
                      <RSelect
                        name="roleId"
                        onChange={(e) => setFormData({ ...formData, roleId: e.value })}
                        placeholder="Please select role"
                        options={roleManagementOptions}
                      />
                      {errors.roleId && (
                        <span className="invalid text-danger" style={{ fontSize: "12px" }}>
                          {errors.roleId.message}
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn && <Spinner size="sm" />}
                          {isLoadBtn ? "Loading" : "Submit"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit User</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        defaultValue={formData.firstName}
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.firstName && <span className="invalid">{errors.firstName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Middle Name</label>
                      <input
                        type="text"
                        name="middleName"
                        defaultValue={formData.middleName}
                        placeholder="Middle Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        defaultValue={formData.lastName}
                        placeholder="Last Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.lastName && <span className="invalid">{errors.lastName.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Email</label>
                      <input
                        type="text"
                        name="email"
                        defaultValue={formData.email}
                        placeholder="Email"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.email && <span className="invalid">{errors.email.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        name="status"
                        value={statusOptions.filter(({ value }) => value === formData.status)[0]}
                        onChange={(e) => handleSelectChange(e, "status")}
                        // ref={register({
                        //   required: "Status is required",
                        // })}
                      />
                      {errors.status && (
                        <span className="invalid text-danger font-italic" style={{ fontSize: "12px" }}>
                          {errors.status.message}
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Branch</label>
                      <RSelect
                        name="branchId"
                        options={branchManagementOptions}
                        value={branchManagementOptions.filter(({ value }) => value === formData.branchId)[0]}
                        // ref={register({
                        //   required: "Branch is required",
                        // })}
                        onChange={(e) => handleSelectChange(e, "branchId")}
                      />

                      {errors.branchId && (
                        <span className="invalid text-danger font-italic" style={{ fontSize: "12px" }}>
                          {errors.branchId.message}
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Department</label>
                      <RSelect
                        options={departmentManagementOptions}
                        // ref={register({
                        //   required: "Department is required.",
                        // })}
                        value={departmentManagementOptions.filter(({ value }) => value === formData.departmentId)[0]}
                        name="departmentId"
                        onChange={(e) => handleSelectChange(e, "departmentId")}
                      />
                      {errors.departmentId && (
                        <span className="invalid text-danger" style={{ fontSize: "12px" }}>
                          {errors.departmentId.message}
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Gender</label>
                      <RSelect
                        options={genderOptions}
                        value={genderOptions.filter(({ value }) => value === formData.genderId)[0]}
                        name="gender"
                        placeholder="Select Gender"
                        onChange={(e) => setFormData({ ...formData, genderId: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Roles</label>
                      <RSelect
                        name="roleId"
                        value={roleManagementOptions.filter(({ value }) => value === formData.assignedRoleId)[0]}
                        onChange={(e) => setFormData({ ...formData, assignedRoleId: e.value })}
                        placeholder="Please select role"
                        options={roleManagementOptions}
                      />
                      {errors.roleId && (
                        <span className="invalid text-danger" style={{ fontSize: "12px" }}>
                          {errors.roleId.message}
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn && <Spinner size="sm" />}
                          {isLoadBtn ? "Loading" : "Update"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.view} toggle={() => setModal({ view: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">View User</h5>
              <div className="mt-4">
                <div className="d-flex justify-content-between align-items-center my-2">
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Full Name: </span>
                      <span>{details?.contactName}</span>
                    </p>
                  </Col>
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Email Address: </span>
                      <span>{details?.email}</span>
                    </p>
                  </Col>
                </div>
                <div className="d-flex justify-content-between align-items-center my-2">
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Gender: </span>
                      <span>{details?.gender?.gender}</span>
                    </p>
                  </Col>
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Role: </span>
                      <span>{details?.assignedRole?.roleName}</span>
                    </p>
                  </Col>
                </div>
                <div className="d-flex justify-content-between align-items-center my-2">
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Referral Code: </span>
                      <span>{details?.myReferralCode}</span>
                    </p>
                  </Col>
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Branch: </span>
                      {details.branch ? <span>{details?.branch.name}</span> : <span>N/A</span>}
                    </p>
                  </Col>
                </div>
                <div className="d-flex justify-content-between align-items-center my-2">
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Department: </span>
                      {details.department ? <span>{details?.department.name}</span> : <span>N/A</span>}
                    </p>
                  </Col>
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Status: </span>
                      <span
                        className={`ml-2 badge badge-dot badge-${
                          details?.status === "ACTIVE" ? "success" : details?.status === "LOCKED" ? "gray" : "danger"
                        }`}
                      >
                        {details?.status}
                      </span>
                    </p>
                  </Col>
                </div>
                <div className="d-flex justify-content-between align-items-center my-2">
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Date Created: </span>
                      <span>{details?.createdAt ?? "N/A"}</span>
                    </p>
                  </Col>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.reset}
          toggle={() => setModal({ unlock: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Are You Sure You Want to Reset This User</h5>
              <div className="mt-4">
                <div className="mt-4">
                  <div className="d-flex justify-content-between align-items-center my-2">
                    <Col md="6">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">Full Name: </span>
                        <span>{details?.contactName}</span>
                      </p>
                    </Col>
                    <Col md="6">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">Email Address: </span>
                        <span>{details?.email}</span>
                      </p>
                    </Col>
                  </div>
                  <div className="d-flex justify-content-between align-items-center my-2">
                    <Col md="6">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">Role: </span>
                        <span>{details?.role}</span>
                      </p>
                    </Col>
                    <Col md="6">
                      <p className="p-0 m-0">
                        <span className="font-weight-bold">Status: </span>
                        <span
                          className={`ml-2 badge badge-dot badge-${
                            details?.status === "ACTIVE" ? "success" : details?.status === "LOCKED" ? "gray" : "danger"
                          }`}
                        >
                          {details?.status}
                        </span>
                      </p>
                    </Col>
                  </div>
                </div>
                <Form className="row gy-4 mt-4" onSubmit={handleSubmit()}>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button
                            color="primary"
                            size="md"
                            onClick={(ev) => {
                              ev.preventDefault();
                              resetUser(details?.email);
                            }}
                          >
                            Confirm Reset
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
